var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"pop",staticClass:"popover-wrapper",class:{show: _vm.show},style:({display: _vm.display ?'block':'none'})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }